import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormContext, useWatch } from 'react-hook-form';
import { InputTextarea } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { isRequired } from '../../../../utils/validationUtils';
import { FORM_KEYS } from '../../../../constants/formKeys';

export const BriefClaimSummary = ({ isReadOnly, claimDescription = '', selectedPet }) => {
  const formContext = useFormContext();
  const { control, setValue, formState } = formContext;

  const claimSummary = useWatch({
    control,
    name: FORM_KEYS.CLAIM_SUMMARY
  });

  useEffect(() => {
    setValue(FORM_KEYS.CLAIM_SUMMARY, claimDescription || '');
  }, [claimDescription, setValue]);

  const charCount = claimSummary?.length || 0;

  return (
    <fieldset>
      <h3>Please provide a brief summary of your claim</h3>
      <p>This will help you easily locate and track your claim.</p>

      <div className="textareaContainer">
        <InputTextarea
          name={FORM_KEYS.CLAIM_SUMMARY}
          label="Summary of your claim"
          inputCustomCssClass={formState.errors.claimSummary ? 'textareaCustomError' : ''}
          hideLabel
          validation={{
            required: isRequired('Please fill in your claim summary.'),
            maxLength: {
              value: 150,
              message: 'Maximum 150 characters allowed.'
            }
          }}
          fieldFormContext={formContext}
          readOnly={isReadOnly}
          maxLength={150}
          placeholder={selectedPet ? `e.g ${selectedPet}'s Snake bite` : 'e.g Snake bite'}
        />
        <div className="characterCounter">{charCount} OUT OF 150 CHARACTERS</div>
      </div>
    </fieldset>
  );
};

BriefClaimSummary.propTypes = {
  isReadOnly: PropTypes.bool,
  claimDescription: PropTypes.string,
  selectedPet: PropTypes.string
};
